import { NavLink } from "react-router-dom";
import Button from ".";
import styles from './index.module.css'

const CategoryButton = ({ id, icon, title, variant }) => {
  return (
    <NavLink
      className={styles.category_btn_wrapper}
      to={`/categories/${id}?pg=1`}
    >
      <div className={styles.category_btn}>
        <img src={icon} alt="title" />
      </div>
      <div className={styles.category_btn_title}>
        {title}
      </div>
    </NavLink>
  );
};

export default CategoryButton;
